const state = {
  color: "Negro",
  colors: ["Negro", "Negro", "Negro"],
  pack: "2 unidades",
  price: "$59.990",
  comparePrice: "$119.980",
  saveText: "Lanzamiento · Ahorrás $59.990",
  installment: "$19.997",
  cartCount: 0,
  variantId: null,
};

const reviews = [
  { name: "Gabriela M.", date: "24/05/2026", stars: 5, text: "Tengo el pelo rubio y al principio no sabía si me iba a funcionar. La primera pasada no hizo tanto, pero con la segunda ya se emparejó bien y me quedó natural.", img: "assets/tonomax/review-wall-woman-01-blonde-ar.jpg" },
  { name: "Samanta A.", date: "21/05/2026", stars: 5, text: "Lo dejé un poquito más de 10 minutos porque quería un tono más profundo. Quedé contenta con lo fácil que fue aplicarlo.", img: "assets/tonomax/review-wall-woman-02.jpg" },
  { name: "Virginia W.", date: "24/05/2026", stars: 4, text: "Muy buen producto. El color del pelo quedó genial y no tiene olor fuerte como otras tinturas.", img: "assets/tonomax/review-wall-woman-03.jpg" },
  { name: "Carla M.", date: "28/05/2026", stars: 5, text: "Siempre tengo canas alrededor de la cara. TonoMax me cubrió perfecto, sin mancharme la piel.", img: "assets/tonomax/review-wall-woman-04.jpg" },
  { name: "Verónica M.", date: "03/06/2026", stars: 5, text: "Me gustó porque no me dejó el pelo pesado ni con olor fuerte. Las canas de la raya quedaron mucho más disimuladas y naturales.", img: "assets/tonomax/review-wall-woman-05.jpg" },
  { name: "Laura M.", date: "02/06/2026", stars: 5, text: "Me lo puse antes de salir y en un rato tenía mucho más prolijas las canas de la frente. No deja el pelo duro ni raro.", img: "assets/tonomax/review-wall-woman-06.jpg" },
  { name: "Marta G.", date: "06/06/2026", stars: 5, text: "Lo empecé a usar porque no quería teñirme todos los meses. En mi pelo corto se nota mucho menos la cana y me siento más prolija.", img: "assets/tonomax/review-wall-woman-07.jpg" },
  { name: "Verónica S.", date: "04/06/2026", stars: 5, text: "Tengo el pelo ondulado y se me notan las canas cerca de la frente. Las cubrí rápido sin que quedara duro ni raro.", img: "assets/tonomax/review-wall-woman-08.jpg" },
];

const additionalReviews = [
  {
    "name": "Borrador 01",
    "draft": true,
    "text": "Quería algo simple para hacerme en casa, sin llenar el baño de potes. Dejo el frasco ahí a mano y listo.",
    "img": "assets/tonomax/review-final-01-v1.png",
    "imageAlt": "Foto generada para maqueta: frasco de TonoMax sobre una mesada blanca de baño."
  },
  {
    "name": "Borrador 02",
    "draft": true,
    "text": "Las canas de adelante me molestaban un montón. Me ataba el pelo y se veían todas. Quería que quedara parejo, no ese color todo pintado.",
    "img": "assets/tonomax/review-final-02-v1.png",
    "imageAlt": "Foto generada para maqueta: detalle de la línea del cabello de una mujer con tono castaño."
  },
  {
    "name": "Borrador 03",
    "draft": true,
    "text": "Soy rubia y me daba cosa terminar con el pelo oscuro. Quería tapar las canas, pero que a la luz del día se siguiera viendo mi color.",
    "img": "assets/tonomax/review-final-03-v1.png",
    "imageAlt": "Foto generada para maqueta: selfie de una mujer con cabello rubio miel, sin frasco."
  },
  {
    "name": "Borrador 04",
    "draft": true,
    "text": "Con el pelo corto se me nota la raíz al toque. No quiero cambiar el look, sólo verme más prolija y hacerlo en casa.",
    "img": "assets/tonomax/review-final-04-v1.png",
    "imageAlt": "Foto generada para maqueta: mujer de cabello castaño corto sosteniendo un frasco de TonoMax."
  },
  {
    "name": "Borrador 05",
    "draft": true,
    "text": "Yo primero miro bien los tonos y cómo se usa. Prefiero elegir tranquila, antes que llevarme un color que después nada que ver.",
    "img": "assets/tonomax/review-final-05-v1.png",
    "imageAlt": "Foto generada para maqueta: mujer con TonoMax en una escena ficticia de supermercado; no acredita distribución comercial."
  },
  {
    "name": "Borrador 06",
    "draft": true,
    "text": "Para estar toda la tarde con la tintura, paso. Buscaba algo para hacerme en mi baño, siguiendo los pasos y sin tanta vuelta.",
    "img": "assets/tonomax/review-final-06-v1.png",
    "imageAlt": "Foto generada para maqueta: frasco de TonoMax apoyado en un estante de ducha."
  },
  {
    "name": "Borrador 07",
    "draft": true,
    "text": "Tengo el pelo oscuro y las canas de la raya se re notan. Quería emparejar el color, sin que quedara todo como pintado.",
    "img": "assets/tonomax/review-final-07-v1.png",
    "imageAlt": "Foto generada para maqueta: detalle de la raya del cabello negro de una mujer."
  },
  {
    "name": "Borrador 08",
    "draft": true,
    "text": "Tengo rulos. Quiero tapar las canas, pero seguir con mi castaño claro y usar el pelo suelto como siempre.",
    "img": "assets/tonomax/review-final-08-v1.png",
    "imageAlt": "Foto generada para maqueta: selfie de una mujer con rulos castaños claros, sin frasco."
  },
  {
    "name": "Borrador 09",
    "draft": true,
    "text": "Antes de arrancar me leo bien las instrucciones. Me gusta saber cuánto poner, cómo aplicarlo y cómo enjuagar, así no hago cualquiera.",
    "img": "assets/tonomax/review-final-09-v1.png",
    "imageAlt": "Foto generada para maqueta: frasco y caja de TonoMax sobre una mesada de baño."
  },
  {
    "name": "Borrador 10",
    "draft": true,
    "text": "Con el trabajo y la casa, el turno para la pelu siempre termina quedando para después. Necesitaba algo para hacerme cuando me queda un rato.",
    "img": "assets/tonomax/review-final-10-v1.png",
    "imageAlt": "Foto generada para maqueta: mujer de cabello oscuro ondulado sosteniendo TonoMax en una cocina."
  },
  {
    "name": "Borrador 11",
    "draft": true,
    "text": "Entre lo que sale la pelu y tener que acomodar los horarios cada vez... quería poder hacerlo en casa y darme un rato para mí."
  },
  {
    "name": "Borrador 12",
    "draft": true,
    "text": "No quiero otro color ni cambiarme el look. Sólo disimular las canas y que siga siendo mi pelo, con los reflejos de siempre."
  }
];

let shownReviews = 0;
const reviewStep = 4;
// Forces Shopify/CDN to refresh pack-duration copy after theme deploys.
const packCopy = {
  "1 unidad": "Para 2 meses + envío gratis",
  "2 unidades": "Para 4 meses + 3 cuotas sin interés + envío gratis",
  "3 unidades": "Para 6 meses + 3 cuotas sin interés + envío gratis",
};

function assetPath(path) {
  return (window.TONOMAX_ASSETS && window.TONOMAX_ASSETS[path]) || path;
}

function normalizeOption(value) {
  return String(value || "")
    .toLocaleLowerCase("es-AR")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, " ")
    .trim();
}

function packKey(value) {
  const number = String(value || "").match(/\d+/);
  return number ? `${number[0]} unidad` : normalizeOption(value);
}

function formatMoney(cents) {
  const amount = Math.round(Number(cents || 0) / 100);
  return `$${amount.toLocaleString("es-AR")}`;
}

function getShopifyVariants() {
  return window.TONOMAX_PRODUCT && Array.isArray(window.TONOMAX_PRODUCT.variants)
    ? window.TONOMAX_PRODUCT.variants
    : [];
}

function selectedShopifyVariant() {
  const selectedId = window.TONOMAX_PRODUCT && window.TONOMAX_PRODUCT.selectedVariantId;
  if (!selectedId) return null;

  return getShopifyVariants().find((variant) => {
    return String(variant.id) === String(selectedId);
  }) || null;
}

function currentVariant() {
  state.color = state.colors[0] || state.color;
  return findVariant(state.color, state.pack);
}

function findVariant(colorValue, packValue) {
  const variants = getShopifyVariants();
  if (!variants.length) return null;

  const color = normalizeOption(colorValue);
  const pack = packKey(packValue);

  return variants.find((variant) => {
    return normalizeOption(variant.option1) === color && packKey(variant.option2) === pack;
  }) || null;
}

function syncVariantPricing() {
  const variant = currentVariant();
  if (!variant) return null;

  state.variantId = variant.id;
  state.price = formatMoney(variant.price);
  state.installment = packCount() > 1 ? formatMoney(Number(variant.price) / 3) : state.price;
  return variant;
}

function qs(selector, root = document) {
  return root.querySelector(selector);
}

function qsa(selector, root = document) {
  return Array.from(root.querySelectorAll(selector));
}

function packCount() {
  const match = packKey(state.pack).match(/\d+/);
  return match ? Number(match[0]) : 1;
}

function selectedColors() {
  return state.colors.slice(0, packCount());
}

function selectedPackLabel() {
  return `${state.pack} · ${selectedColors().join(" + ")}`;
}

function cartVariantLabel() {
  return `Pack ${packCount()} · ${selectedColors().join(" + ")}`;
}

function syncPackControls() {
  state.color = state.colors[0] || state.color;

  qsa(".pack-card").forEach((card) => {
    const copy = qs(".pack-card__copy p", card);
    if (copy && packCopy[card.dataset.pack]) {
      copy.textContent = packCopy[card.dataset.pack];
    }
  });

  qsa(".pack-color-select").forEach((select) => {
    const slotIndex = Number(select.dataset.packColor || 0);
    select.value = state.colors[slotIndex] || "Negro";
  });
}

function activatePackCard(card) {
  if (!card) return false;

  qsa(".pack-card").forEach((item) => {
    item.classList.remove("is-active");
    item.setAttribute("aria-checked", "false");
  });
  card.classList.add("is-active");
  card.setAttribute("aria-checked", "true");
  state.pack = card.dataset.pack;
  state.price = card.dataset.price;
  state.comparePrice = card.dataset.comparePrice;
  state.saveText = card.dataset.saveText;
  state.installment = card.dataset.installment;
  return true;
}

function hydrateSelectionFromShopify() {
  const variant = selectedShopifyVariant();
  if (!variant) return false;

  const card = qsa(".pack-card").find((item) => {
    return packKey(item.dataset.pack) === packKey(variant.option2);
  });
  if (!activatePackCard(card)) return false;

  const selectedColor = variant.option1 || state.color;
  const availableColors = new Set(getShopifyVariants().map((item) => item.option1));
  const url = new URL(window.location.href);
  state.color = selectedColor;
  state.colors = [selectedColor, selectedColor, selectedColor];
  for (let index = 1; index < packCount(); index += 1) {
    const linkedColor = url.searchParams.get(`color${index + 1}`);
    if (availableColors.has(linkedColor)) state.colors[index] = linkedColor;
  }
  return true;
}

function syncVariantUrl() {
  if (!state.variantId || !window.history || !window.history.replaceState) return;

  const url = new URL(window.location.href);
  url.searchParams.set("variant", String(state.variantId));
  for (let index = 1; index < 3; index += 1) {
    const key = `color${index + 1}`;
    if (index < packCount()) {
      url.searchParams.set(key, state.colors[index] || state.color);
    } else {
      url.searchParams.delete(key);
    }
  }
  window.history.replaceState(window.history.state, "", url.toString());
}

function updateSelection() {
  syncVariantPricing();
  syncPackControls();
  const setText = (selector, value) => {
    const element = qs(selector);
    if (element) element.textContent = value;
  };

  setText("#currentPrice", state.price);
  setText("#comparePrice", state.comparePrice);
  setText("#priceSave", state.saveText);
  setText("#totalPrice", state.price);
  setText("#stickyPrice", state.price);
  setText("#installment", state.installment);
  const installmentsEligible = packCount() > 1;
  setText("#installmentPrefix", installmentsEligible ? "3 cuotas de" : "1 pago de");
  const installmentNote = qs("#installmentNote");
  if (installmentNote) {
    installmentNote.textContent = installmentsEligible ? "sin interés" : "";
    installmentNote.hidden = !installmentsEligible;
  }
  setText("#selectedColor", state.color);
  setText("#stickyPack", selectedPackLabel());
  setText("#cartVariant", cartVariantLabel());
  setText("#cartPrice", state.price);
}

function selectPack(card) {
  activatePackCard(card);
  updateSelection();
  syncVariantUrl();
}
